// Import necessary dependencies from Material-UI and React
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import Select from '@mui/material/Select';
import Grid2 from '@mui/material/Unstable_Grid2';
import CompareArrowsIcon from '@mui/icons-material/CompareArrows';
import './CompareSelect.css';

// Import the useSelector hook from react-redux to access the global state
import { useSelector } from "react-redux";

/**
 * CompareSelect component provides a dropdown selection for comparing two coins.
 * @param {string} coinOne - The first selected coin.
 * @param {string} coinTwo - The second selected coin.
 * @param {function} handleCoinOneChange - Function to handle changes in the first selected coin.
 * @param {function} handleCoinTwoChange - Function to handle changes in the second selected coin.
 * @returns {JSX.Element} - CompareSelect component.
 */
const CompareSelect = ({ coinOne, coinTwo, handleCoinOneChange, handleCoinTwoChange }) => {

  // Access the "coins" array from the global state using the useSelector hook
  const coins = useSelector((state) => state.coins);

  // Styling object for the Select component
  let style = {
    width: "100%",
    height: "2.5rem",
    color: "var(--theme-color-secondary)",
    "& .MuiOutlinedInput-notchedOutline": {
      borderColor: "var(--theme-color-secondary)",
    },
    "& .MuiSvgIcon-root": {
      color: "var(--theme-color-secondary)",
    },
    "&:hover": {
      "&& fieldset": {
        borderColor: "var(--theme-color-secondary)",
      },
    },
  };

  return (
    <>
      {/* Grid layout for organizing the selection components */}
      <Grid2 container spacing={2}>
        {/* First column in the grid */}
        <Grid2 xs={12} sm={3}>
          {/* InputLabel for the first coin selection */}
          <InputLabel id="demo-simple-select-label" sx={{ color: "white" }} >Select first coin</InputLabel>
          {/* Select component for the first coin */}
          <Select
            labelId="demo-simple-select-label"
            id="demo-simple-select"
            value={coinOne}
            label="coinOne"
            onChange={handleCoinOneChange}
            sx={style}
          >
            {/* Mapping over the coins array to generate MenuItem components */}
            {coins.map((elem) => {
              return (<MenuItem key={elem.id} value={elem.id}>{elem.name}</MenuItem>);
            })}
          </Select>
        </Grid2>
        {/* Second column in the grid */}
        <Grid2 xs={12} sm={6}>
          {/* Container for the comparison arrows icon */}
          <div className="compare-sign-02" style={{ display: "flex", alignItems: "center", justifyContent: "center" }}>
            <div>
              <br />
              {/* CompareArrowsIcon for indicating a comparison */}
              <CompareArrowsIcon sx={{ fontSize: 40, color: "var(--theme-color-primary)" }} />
            </div>
          </div>
        </Grid2>
        {/* Third column in the grid */}
        <Grid2 xs={12} sm={3}>
          {/* InputLabel for the second coin selection */}
          <InputLabel id="demo-simple-select-label" sx={{ color: "white" }} >Select second coin</InputLabel>
          {/* Select component for the second coin */}
          <Select
            labelId="demo-simple-select-label"
            id="demo-simple-select"
            value={coinTwo}
            label="coinTwo"
            onChange={handleCoinTwoChange}
            sx={style}
          >
            {/* Mapping over the coins array to generate MenuItem components */}
            {coins.map((elem) => {
              return (<MenuItem key={elem.id} value={elem.id}>{elem.name}</MenuItem>);
            })}
          </Select>
        </Grid2>
      </Grid2>
    </>
  );
}

// Export the CompareSelect component as the default export of the module
export default CompareSelect;
